module.exports = __webpack_public_path__ + "img/title2.f1f04670.webp";